import { useQuery } from "@tanstack/vue-query";
import type { Ref } from "vue";
import Dialer from "@/services/dialer/dialer";
import type { DialerSessionsListParams, DialerSessionsListResult } from "@/dtos/Dialer.dto";

export function useDialerSessions(
  params: Ref<DialerSessionsListParams>,
  enabled: Ref<boolean> | boolean = true
) {
  return useQuery({
    queryKey: ["dialerSession", "list", params] as const,
    queryFn: async (): Promise<DialerSessionsListResult> => {
      const result = await Dialer.getSessions(params.value);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to load dialer session history");
      }
      return result.data.data;
    },
    enabled,
  });
}
